var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72247 2.4402C5.41611 2.25327 5.03614 2.25327 4.72977 2.4402L2.28241 3.93351C1.9834 4.11596 1.7998 4.44892 1.7998 4.80876V7.80641C1.7998 8.16625 1.9834 8.49921 2.28241 8.68166L4.72977 10.175C5.03613 10.3619 5.41611 10.3619 5.72247 10.175L10.7735 7.09299L12.8945 8.38719V10.9976L10.7735 12.2919L8.65244 10.9976V9.35394L7.34717 10.2002V11.1912C7.34717 11.5511 7.53077 11.884 7.82977 12.0665L10.2771 13.5598C10.5835 13.7467 10.9635 13.7467 11.2698 13.5598L13.7172 12.0665C14.0162 11.884 14.1998 11.5511 14.1998 11.1912V8.1936C14.1998 7.83376 14.0162 7.50079 13.7172 7.31835L11.2698 5.82504C10.9635 5.6381 10.5835 5.6381 10.2771 5.82504L5.22612 8.90702L3.10507 7.61281V5.00236L5.22612 3.70816L7.34717 5.00236V6.64607L8.65244 5.79987V4.80876C8.65244 4.44892 8.46884 4.11596 8.16984 3.93351L5.72247 2.4402Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonLogo);
export default __webpack_public_path__ + "static/media/polygonLogo.e026c74663081123372115ad78de287e.svg";
export { ForwardRef as ReactComponent };